module.exports = __webpack_public_path__ + "static/media/Jam9.66c421b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam9.svg
// module id = 610
// module chunks = 0